import { Box, Button, Grid2, Stack } from "@mui/material"
import { actionToAppMainPageUtils, IActionToAppMainPage } from "./IToAppMainPage.intf"
import { childToProjectDataUtils, IChildToProjectData } from "@droid/project-v2-interface"
import { useRouter } from "next/router"
import { IActionOrTriggerListPageParams, ActionOrTriggerListTypeEnum } from "@app/static"
import { useProxyWatch, useTranslation } from "@fanfanlo"

export function UI(data: IActionToAppMainPage) {
    const { t } = useTranslation("droid-project-v2-ext/actions/app/to-app-main-page/content")
    const router = useRouter()
    const backPath = router.pathname
    const [pn] = useProxyWatch(data, "javaData.pn", data.javaData.pn)
    const [an] = useProxyWatch(data, "javaData.an", data.javaData.an)

    function onChangeClick() {
        const projectInfo: IChildToProjectData = {}
        childToProjectDataUtils.actionList.getActionListByProp(data, projectInfo)
        // 修改：属性从 .id 改为 .ulid，URL参数名从 xxxId 改为 xxxUlid
        if (!projectInfo.project?.ulid || !projectInfo.triggerActionGroup?.ulid || !projectInfo.triggerAction?.ulid || !projectInfo.actionGroup?.ulid) {
            console.error('UpdateAppLink projectInfo is undefined', projectInfo)
            return
        }

        const query: IActionOrTriggerListPageParams = {
            backPath,
            projectUlid: projectInfo.project?.ulid,
            triggerActionGroupUlid: projectInfo.triggerActionGroup?.ulid,
            triggerActionUlid: projectInfo.triggerAction?.ulid,
            actionGroupUlid: projectInfo.actionGroup?.ulid,
            type: ActionOrTriggerListTypeEnum.updateAction,
            actionUlid: data.ulid,
            actionType: actionToAppMainPageUtils.type,
        }
        actionToAppMainPageUtils.onClickChange?.({ query })
    }

    return (
        <>
            <Box sx={{ width: "100%" }}>
                <Box>
                    <b>{t("content.title")}</b>
                </Box>
                <Grid2 container sx={{ width: "100%" }}>
                    <Grid2 size="grow" container>
                        <Stack direction="column" spacing={2}>
                            <Box>
                                <span>{t("content.pnName")}</span>
                                <span>{pn}</span>
                            </Box>
                            <Box>
                                <span>{t("content.anName")}</span>
                                <span>{an}</span>
                            </Box>
                        </Stack>
                    </Grid2>
                    <Grid2 size={"auto"}>
                        <Button data-testid="ToAppMainPageUI__changeButton__01JFXYZF7V1W2X3Y4Z5A6B7C8" onClick={onChangeClick}>
                            <span>{t("content.changeBtnLabel")}</span>
                        </Button>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    )
}
